import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { usePlatformAuth } from './platformAuth.js';
import { Button } from '@/components/ui/Button.jsx';
import { cn } from '@/lib/cn.js';
import { Users, Package, LogOut, Shield } from 'lucide-react';

const NAV = [
  { to: '/platform/customers', label: 'Customers', icon: Users },
  { to: '/platform/profiles', label: 'Profiles', icon: Package },
  { to: '/platform/security', label: 'Security', icon: Shield },
];

export default function PlatformShell() {
  const logout = usePlatformAuth((s) => s.logout);
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/platform/login');
  }

  return (
    <div className="flex h-screen bg-slate-50 dark:bg-slate-950">
      <aside className="w-56 flex flex-col border-r border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
        <div className="px-4 py-4 border-b border-slate-200 dark:border-slate-800">
          <span className="text-sm font-semibold text-slate-900 dark:text-slate-100">PayPro Platform</span>
        </div>
        <nav className="flex-1 p-2 space-y-0.5">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => cn(
                'flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors',
                isActive
                  ? 'bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300 font-medium'
                  : 'text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800',
              )}
            >
              <Icon className="h-4 w-4 shrink-0" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-2 border-t border-slate-200 dark:border-slate-800">
          <Button variant="ghost" size="sm" className="w-full justify-start gap-2" onClick={handleLogout}>
            <LogOut className="h-4 w-4" />
            Sign out
          </Button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
